// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `map-search-bar {
  box-shadow: var(--shadow-elevation-low);
  border-radius: var(--border-radius);
}
map-search-bar .result-title {
  margin: var(--element-spacing) 0;
}
map-search-bar .story-image-container {
  width: 100%;
  aspect-ratio: 16/9;
  overflow: hidden;
  border-radius: var(--border-radius);
  display: flex;
}
map-search-bar .story-image-container .street-view {
  width: 100%;
}
map-search-bar .story-image-container .placeholder {
  width: 30%;
  margin: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/editor-page/components/map-search-bar/map-search-bar.component.scss"],"names":[],"mappings":"AAAA;EACI,uCAAA;EACA,mCAAA;AACJ;AACI;EACI,gCAAA;AACR;AAEI;EACI,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,mCAAA;EACA,aAAA;AAAR;AAEQ;EACI,WAAA;AAAZ;AAGQ;EACI,UAAA;EACA,YAAA;AADZ","sourcesContent":["map-search-bar {\n    box-shadow: var(--shadow-elevation-low);\n    border-radius: var(--border-radius);\n    \n    .result-title {\n        margin: var(--element-spacing) 0;\n    }\n\n    .story-image-container {\n        width: 100%;\n        aspect-ratio: 16/9;\n        overflow: hidden;\n        border-radius: var(--border-radius);\n        display: flex;\n\n        .street-view {\n            width: 100%;\n        }\n\n        .placeholder {\n            width: 30%;\n            margin: auto;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
